const {
  GET_PROVINCE_LIST,
  GET_PROVINCE_LIST_FAILED,
  GET_PROVINCE_LIST_SUCCESS,

  GET_DISTRICT_LIST,
  GET_DISTRICT_LIST_FAILED,
  GET_DISTRICT_LIST_SUCCESS,

  GET_WARD_LIST,
  GET_WARD_LIST_FAILED,
  GET_WARD_LIST_SUCCESS,
} = require('./actionTypes');

export const COUNTRIES_API_PROVIDE = {
  VIETNAM: 'VN',
};

const initialState = {
  countries: COUNTRIES_API_PROVIDE.VIETNAM,

  loadingProvinces: false,
  provinces: [],

  loadingDistricts: false,
  districts: [],

  loadingWards: false,
  wards: [],
};

const address = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVINCE_LIST:
      return {
        ...state,
        loadingProvinces: true,
      };

    case GET_PROVINCE_LIST_SUCCESS:
      return {
        ...state,
        loadingProvinces: false,
        provinces: action.payload,
      };

    case GET_PROVINCE_LIST_FAILED:
      return {
        ...state,
        loadingProvinces: false,
      };

    case GET_DISTRICT_LIST:
      return {
        ...state,
        loadingDistricts: true,
      };

    case GET_DISTRICT_LIST_SUCCESS:
      return {

        ...state,
        loadingDistricts: false,
        districts: action.payload,
      };

    case GET_DISTRICT_LIST_FAILED:
      return {
        ...state,
        loadingDistricts: false,
      };

    case GET_WARD_LIST:
      return {
        ...state,
        loadingWards: true,
      };

    case GET_WARD_LIST_SUCCESS:
      return {
        ...state,
        loadingWards: false,
        wards: action.payload,
      };

    case GET_WARD_LIST_FAILED:
      return {
        ...state,
        loadingWards: false,
      };

    default:
      return state;
  }
};

export default address;
